import React, { useState } from 'react';
import clsx from 'clsx';
import {
  makeStyles,
  TextField,
  Typography,
  InputBase,
} from '@material-ui/core';

import Style from './Style';
import Buttons from '../Buttons';
import CustomerSearchBar from '../CustomerSearchBar';

const useStyles = makeStyles(() => Style());

export default function CustomerFields({ setToggle }) {
  const classes = useStyles();

  const [selectedCustomer, setSelectedCustomer] = useState();

  const {
    id = '',
    name = '',
    phone = '',
    email = '',
    company = null,
    usDotNumber = '',
    pstNumber = '',
    notes = '',
  } = selectedCustomer || '';

  return (
    <div className={classes.customer__main}>
      <Typography className={classes.heading}>Search Customer</Typography>

      {/* Customer Search Bar */}
      <CustomerSearchBar setSelectedCustomer={setSelectedCustomer} />

      <div className={clsx(classes.fields__main, 'w-100')}>
        <div className='d-flex space-between'>
          <div className={clsx(classes.flex__field)}>
            <Typography className={classes.label}>Name</Typography>
            <TextField
              disabled
              value={name}
              fullWidth
              InputProps={{
                disableUnderline: true,
              }}
              className={clsx(classes.data__field, 'c-pointer')}
            />
          </div>
          <div className={clsx(classes.flex__field)}>
            <Typography className={classes.label}>Phone Number</Typography>
            <TextField
              disabled
              value={phone}
              fullWidth
              InputProps={{
                disableUnderline: true,
              }}
              className={clsx(classes.data__field, 'c-pointer')}
            />
          </div>
        </div>
        <div className='d-flex space-between'>
          <div className={clsx(classes.flex__field)}>
            <Typography className={classes.label}>Email</Typography>
            <TextField
              disabled
              value={email}
              fullWidth
              InputProps={{
                disableUnderline: true,
              }}
              className={clsx(classes.data__field, 'c-pointer')}
            />
          </div>
          <div className={clsx(classes.flex__field)}>
            <Typography className={classes.label}>Company</Typography>
            <TextField
              disabled
              value={company}
              fullWidth
              InputProps={{
                disableUnderline: true,
              }}
              className={clsx(classes.data__field, 'c-pointer')}
            />
          </div>
        </div>
        <div className='d-flex space-between'>
          <div className={clsx(classes.flex__field)}>
            <Typography className={classes.label}>USDOT Number</Typography>
            <TextField
              disabled
              value={usDotNumber || ''}
              fullWidth
              InputProps={{
                disableUnderline: true,
              }}
              className={clsx(classes.data__field, 'c-pointer')}
            />
          </div>
          <div className={clsx(classes.flex__field)}>
            <Typography className={classes.label}>PST Number</Typography>
            <TextField
              disabled
              value={pstNumber || ''}
              fullWidth
              InputProps={{
                disableUnderline: true,
              }}
              className={clsx(classes.data__field, 'c-pointer')}
            />
          </div>
        </div>
        <div className='d-flex space-between'>
          <div style={{ width: '100%' }}>
            <Typography className={classes.label}>Customer Notes</Typography>
            <div
              style={{
                border: '1px solid #AEB6B7',
                borderRadius: '8px',
                padding: '0 1rem',
              }}
            >
              <InputBase disabled multiline rows={3} fullWidth value={notes} />
            </div>
          </div>
        </div>
      </div>

      {/* Actions */}
      <Buttons
        classes={classes}
        onCancel={() => {
          setToggle(false);
        }}
        selectedCustomer={selectedCustomer}
        disabled={!id || !name || !phone}
      />
    </div>
  );
}
